module.exports = __webpack_public_path__ + "static/media/AwakenedDragon.06bb4337.png";